export const getConditionalClassName = (
  condition: boolean,
  trueValue: string,
  falseValue: string = "",
): string => (condition ? trueValue : falseValue);

export const combineClassNames = (...classNames: (string | undefined | null | false)[]): string =>
  classNames.filter(Boolean).join(" ");
